import { formEvents } from "./form-events.js";

document.addEventListener("DOMContentLoaded", () => {
	formEvents();
});
